import { AuthStorage } from "utils/auth-storage";
import * as yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { AuthService } from "apis/Services/AuthService";
import AuthWrapper from "components/auth-page-wrapper";
import ButtonComponent from "components/button-component";
import InputComponent from "components/input-component";
import React, { useEffect } from "react";
import Text from "components/text";
import styles from "./login.module.css";
import { useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { SidePanelSubmittalsService } from "apis/Services/SidePanelSubmittalsService";

const LoginSidePanel = ({
  companyId,
  setEmail,
  email,
  setCode,
  code,
  setIsUserAuthorized,
  getSubmittals,
}) => {
  const navigate = useNavigate();
  const [loginError, setloginError] = useState(null);
  const [showPassword, setshowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  let schema = yup.object().shape({
    loginEmail: yup
      .string()
      .required("This field is required")
      .email("Please enter a valid email"),
    loginPassword: yup.string().required("This field is required"),
  });

  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      loginEmail: "",
      loginPassword: "",
      remember: false,
    },
    resolver: yupResolver(schema),
  });

  const retrieveUserTokens = async (loginEmail) => {
    let requestData = {
      email: loginEmail,
    };

    console.log(requestData, "retrieveUserTokens");

    try {
      const res = await SidePanelSubmittalsService.retrieveUserTokens(
        requestData
      );

      let code = res?.accessToken;
      let refreshCode = res?.refreshToken;
      setCode(res?.accessToken);

      let data = {
        loginEmail,
        access_token: code,
        refresh_token: refreshCode,
        company_id: companyId,
      };
      AuthService.refreshToken(data)
        .then((res) => {
          setCode(res.access_token);
          AuthStorage.setItem("token", res.access_token);
          AuthStorage.setItem("refreshToken", res.refresh_token);
          AuthStorage.setItem("lastRequestTime", new Date().getTime());

          getSubmittals(loginEmail, res?.access_token);
          setIsUserAuthorized(true);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = async (v) => {
    await AuthService.post_login(v)
      .then((res) => {
        setLoading(true);
        setEmail(v.loginEmail);
        AuthStorage.setItem("email", v.loginEmail);
        AuthStorage.setItem("lastRequestTime", new Date().getTime());

        retrieveUserTokens(v.loginEmail);
      })
      .catch((err) => {
        console.log(err, "err");
        setloginError(true);
        setLoading(false);
      });
  };

  const switchShowPassword = () => {
    setshowPassword(!showPassword);
  };

  return (
    <AuthWrapper logoNavigate={false}>
      {/* <Spin indicator={indicator} spinning={loader}> */}
      <form onSubmit={handleSubmit(onSubmit)}>
        <Text fontSize={38} className="mb-4 fw-bold text-wrap">
          Welcome to Koncurent
        </Text>
        <div className="d-flex flex-column mt-3">
          <Controller
            name="loginEmail"
            control={control}
            render={({ field }) => (
              <InputComponent
                label="Email"
                errors={errors.loginEmail}
                placeholder="Enter your email"
                {...field}
              />
            )}
          />
          {errors?.loginEmail && (
            <Text className={styles.errorText}>
              {errors.loginEmail.message}
            </Text>
          )}
          <div className="d-flex align-items-center">
            <div className="flex-grow-1">
              <Controller
                name="loginPassword"
                control={control}
                render={({ field }) => (
                  <InputComponent
                    label="Password"
                    errors={errors.loginPassword}
                    className={"my-2"}
                    placeholder="Enter your password"
                    type={showPassword ? "text" : "password"}
                    {...field}
                  />
                )}
              />
            </div>
            <div className="pointer p-3 pt-4 mt-3" onClick={switchShowPassword}>
              {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
            </div>
          </div>
          {errors?.loginPassword && (
            <Text className={styles.errorText}>
              {errors.loginPassword.message}
            </Text>
          )}

          <div className="d-flex justify-content-between w-100 flex-wrap flex-md-nowrap my-2 ">
            <div className="d-flex  gap-1">
              <Text className={`${styles.forgetPass}`}>
                Forgot your password
              </Text>
              <Text
                className={`${styles.link} pointer`}
                onClickAction={() => navigate("/forget-password")}
              >
                Click here.
              </Text>
            </div>
          </div>
          {loginError && (
            <Text className={styles.errorText}>
              You have entered an invalid username or password
            </Text>
          )}
          <ButtonComponent
            isLoading={loading}
            title={"Login"}
            className={`mt-3`}
            disabled={loading}
          />
        </div>
      </form>
      {/* </Spin> */}
    </AuthWrapper>
  );
};

export default LoginSidePanel;
